import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

enum Selectors {
  // Target
  CTAbutton = '.MuiButton-root',
  CTAlink = '.MuiLink-root',
}

export const mapTarget = mapTargetBySelectors([Selectors.CTAbutton, Selectors.CTAlink]);

export const onDatalayer = ({ target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const href = target?.href || '';
  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;

  return {
    event: 'clickCTA',
    eventCategory: 'Rich Content',
    ...(!!href && { href }),
    ...(variantName && { variant_name: variantName }),
  };
};
